import { Button } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'

import { isEqualWorkspace } from '../../../../workspace/helpers'
import { useRequiredWorkspaceOperationsContext } from '../../../../workspace/operationsContext'
import { useWorkspaceManagerContext } from '../../../../workspace/workspaceManagerContext'

export const CloseWorkspaceButton = () => {
  const translate = useTranslate()
  const { onSwitch, currentWorkspaceKey } = useWorkspaceManagerContext()
  const { workspaceKey } = useRequiredWorkspaceOperationsContext()
  const isWorkspaceOpen = isEqualWorkspace(workspaceKey, currentWorkspaceKey)

  return (
    <Button
      startIcon="XCircle"
      onClick={() => onSwitch(null)}
      disabled={!isWorkspaceOpen}
    >
      {translate('workspaceDetailsPanel.button.closeWorkspace')}
    </Button>
  )
}
